import React from 'react';
import PropTypes from 'prop-types';
// import Knob from 'react-canvas-knob';
import { Modal } from 'antd';
import { I18n as I } from 'react-redux-i18n';

import moment from 'moment';
import 'moment/locale/el';

// // import Knob from 'react-canvas-knob';
// import { Modal } from 'react-bootstrap';

// import { LoaderOverlay, bind, isFunc, isObject, toDateTimeString } from 'vdlib';

// const defaultDuration = 36;
// const themeColors = {
//   darkBlue: { fgColor: '#5E738B', bgColor: '#E1E5EC' },
// };
// const defaultTheme = 'darkBlue';

// class AuctionDurationModal extends React.Component {
//   constructor(props) {
//     super(props);

//     bind(this, [
//       'populate',
//       'getDisplay',
//       'getExpiryDate',
//       'onKnobChange',
//       'onKnobChangeEnd',
//       'onHide',
//       'onSubmit',
//     ]);

//     this.state = { value: props.initialDuration || defaultDuration };
//     this.populate(props);
//   }

//   componentWillReceiveProps(nextProps) {
//     if (
//       this.props.initialDuration != nextProps.initialDuration ||
//       this.props.theme != nextProps.theme
//     )
//       this.populate(nextProps);
//   }

//   populate(props) {
//     this.theme = themeColors[this.props.theme] || themeColors[defaultTheme];
//     this.setState({ value: props.initialDuration || defaultDuration });
//   }

//   getDisplay() {
//     let days = Math.floor(this.state.value / 24),
//       hours = this.state.value - days * 24,
//       hoursText = `${hours} ${I.t('HOURS_MISSING_ENDING')}${
//         hours == 1 ? I.t('ENDING_FEMALE_SINGULAR') : I.t('ENDING_FEMALE_PLURAL')
//       }`,
//       extraStyle = { color: this.theme.fgColor };
//     if (days == 0) extraStyle.lineHeight = '55px';

//     return (
//       <div className="auction-duration-display" style={extraStyle}>
//         {days > 0
//           ? [
//               `${days} ${I.t('DAYS_MISSING_ENDING')}${
//                 days == 1
//                   ? I.t('ENDING_FEMALE_SINGULAR')
//                   : I.t('ENDING_FEMALE_PLURAL')
//               }`,
//               <br />,
//               hoursText,
//             ]
//           : hoursText}
//       </div>
//     );
//   }

//   getExpiryDate() {
//     let dt = new Date();
//     dt.setHours(dt.getHours() + this.state.value);
//     return toDateTimeString(dt, { weekday: 'long', second: undefined });
//   }

//   onKnobChange(value) {
//     this.setState({ value });
//   }

//   onKnobChangeEnd(value) {}

//   onHide(e) {
//     if (isFunc(this.props.onHide)) this.props.onHide(e);
//   }

//   onSubmit(e) {
//     let finalDate = new Date();
//     finalDate.setHours(finalDate.getHours() + this.state.value);

//     if (isFunc(this.props.onSubmit)) this.props.onSubmit(finalDate);
//   }

//   render() {
//     return (
//       <Modal
//         animation={true}
//         className="fade-scale"
//         show={this.props.show}
//         onHide={this.onHide}
//         dialogClassName="custom-modal"
//         style={{ top: '22%' }}
//       >
//         <Modal.Header>
//           <Modal.Title>
//             {this.props.title || I.t('AUCTION_DURATION')}
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body className="form-horizontal">
//           <LoaderOverlay loading={this.props.loading === true} />
//           <br />
//           <div className="auction-duration">
//             {/* <Knob
//               value={this.state.value}
//               onChange={this.onKnobChange}
//               onChangeEnd={this.onKnobChangeEnd}
//               fgColor={this.theme.fgColor}
//               bgColor={this.theme.bgColor}
//               min={1}
//               max={240}
//               step={1}
//               angleOffset={240}
//               angleArc={240}
//               displayInput={false}
//               displayCustom={this.getDisplay}
//             /> */}
//             <div className="auction-duration-caption">
//               <span className="bold">{I.t('END')}:</span> {this.getExpiryDate()}
//             </div>
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           {isObject(this.props.submitButton) ? (
//             this.props.submitButton
//           ) : (
//             <button
//               type="button"
//               className={`btn btn-primary btn-sm float-right ml-sm ${
//                 this.props.loading ? 'disabled' : ''
//               } `}
//               disabled={this.props.loading}
//               onClick={this.onSubmit}
//             >
//               {this.props.submitButton || I.t('SAVE_INPUT')}
//             </button>
//           )}
//           {isObject(this.props.cancelButton) ? (
//             this.props.cancelButton
//           ) : (
//             <button
//               type="button"
//               className={`btn btn-default btn-sm float-right ${
//                 this.props.loading ? 'disabled' : ''
//               }`}
//               disabled={this.props.loading}
//               onClick={this.onHide}
//             >
//               {this.props.cancelButton || I.t('CANCEL')}
//             </button>
//           )}
//         </Modal.Footer>
//       </Modal>
//     );
//   }
// }

// AuctionDurationModal.propTypes = {
//   initialDuration: PropTypes.number,
//   loading: PropTypes.bool,
//   onHide: PropTypes.func.isRequired,
//   onSubmit: PropTypes.func.isRequired,
//   show: PropTypes.bool,
//   theme: PropTypes.string,
//   title: PropTypes.string,
// };

import {
  LoaderOverlay,
  //parseFieldAmount,
  //formatAmount,
  //formatFieldAmount,
  isFunc,
} from 'vdlib';

import {
  //Checkbox,
  Form,
  Input,
  InputNumber,
  Slider,
  Row,
  Col,
  Card,
} from 'antd';

const { TextArea } = Input;

const defaultDuration = 120;

const AuctionDurationModal = ({
  marketValue,
  cancelButton,
  loading,
  onHide,
  onSubmit,
  show,
  submitButton,
  title,
  comments,
}) => {
  const [form] = Form.useForm();

  const [formData, _setFormData] = React.useState({
    comments: comments,
    dirty: false,
    duration: defaultDuration,
  });

  const [sliderValue, setSliderValue] = React.useState(defaultDuration);

  const setFormData = React.useCallback(
    (name, value) =>
      _setFormData(fd => ({ ...fd, [name]: value, dirty: true })),
    [_setFormData]
  );

  const handleSubmit = React.useCallback(() => {
    let finalDate = moment.utc();
    finalDate.add(formData.duration, 'hours');

    if (isFunc(onSubmit)) {
      onSubmit(finalDate.toDate(), formData.comments);
    }
  }, [formData, onSubmit]);

  const handleHide = React.useCallback(() => {
    if (isFunc(onHide)) onHide();
  }, [onHide]);

  const onFormValuesChange = (changedValues, allValues) => {
    setFormData(Object.keys(changedValues)[0], Object.values(changedValues)[0]);
  };

  const sliderMarks = React.useMemo(() => {
    let marks = {};

    for (let index = 24; index <= 240; index += 24)
      marks[index] = {
        style: {
          color: '#1373A9',
        },
        label: `${index / 24} Ημέρες`,
      };

    return marks;
  }, []);

  const onChange = value => {
    setSliderValue(value);
    setFormData('duration', value);
  };

  return (
    <Modal
      width={700}
      onHide={handleHide}
      visible={show}
      title={title}
      okText={submitButton}
      cancelText={cancelButton}
      onCancel={handleHide}
      onOk={() => {
        form
          .validateFields()
          .then(values => {
            form.resetFields();
            handleSubmit(values);
          })
          .catch(info => {
            console.error('Validate Failed:', info);
          });
      }}
      bodyStyle={{ padding: 2 }}
    >
      <LoaderOverlay loading={loading === true} />
      <Form
        layout="vertical"
        form={form}
        name="duration-modal"
        onValuesChange={onFormValuesChange}
        initialValues={{
          comments: comments,
          duration: formData.duration,
        }}
        style={{ backgroundColor: '#efefef', padding: 10 }}
      >
        <Row>
          <Col span={8}>
            <Card title={I.t('DURATION')}>
              <Form.Item
                name="duration"
                label=""
                style={{ marginLeft: 22, marginBottom: 0 }}
              >
                <Row>
                  <Slider
                    style={{ display: 'inline-block', height: 320 }}
                    vertical
                    marks={sliderMarks}
                    included={false}
                    step={1}
                    min={1}
                    max={240}
                    value={typeof sliderValue === 'number' ? sliderValue : 0}
                    onChange={onChange}
                  />
                </Row>
                <Row>
                  <InputNumber
                    style={{ width: 100 }}
                    min={1}
                    max={240}
                    value={sliderValue}
                    onChange={onChange}
                    prefix="Ωρες"
                    formatter={value => `${value}${I.t('HOURS')}`}
                    parser={value => value.replace(I.t('HOURS'), '')}
                  />
                </Row>
              </Form.Item>
            </Card>
          </Col>
          <Col span={16}>
            <Card
              title={I.t('AUCTION_INFO')}
              style={{ width: '100%', height: '100%' }}
            >
              <Form.Item
                name="comments"
                label={I.t('COMMENTS')}
                requiredMark="optional"
              >
                <TextArea
                  value={formData.comments}
                  placeholder="Comments"
                  autoSize={{ minRows: 2, maxRows: 6 }}
                />
              </Form.Item>
            </Card>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

AuctionDurationModal.propTypes = {
  loading: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  show: PropTypes.bool,
  theme: PropTypes.string,
  title: PropTypes.string,
};

export default AuctionDurationModal;
